import React, { Component } from 'react';
import autoBind from 'react-autobind/src/autoBind';
import { withTranslation } from 'react-i18next';
import ConfirmDialog from 'src/components/misc/confirm-dialog';
import { ButtonColors } from 'src/utils/constants';
import composeModalActions from 'src/utils/modal-action-wrapper';
import { asyncRequest, Entities, TOMCAT_URL } from 'src/common';

class AdminGeofenceAreaItems extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: '',
            inEditMode: null,
        };
        autoBind(this);
    }

    // Handles text changes in the search input field
    handleSearchChange(event) {
        this.setState({ searchQuery: event.target.value });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.editGeofence !== this.props.editGeofence) {
            this.setState({ inEditMode: this.props.editGeofence });
        }
    }

    openConfirmDeleteDialog(calculation, calculations) {
        const { t } = this.props;

        this.props.openModal({
            component: ConfirmDialog,
            componentProps: {
                event: calculation,
                onProceedDialog: () => {
                    this.props.deleteGeoFenceArea(calculation.id).then(() => {
                        this.props.search(Entities.GEOFENCE_AREA, `get-all`, 0, undefined, true);
                        this.props.addNotification(
                            t('common_phrases.success'),
                            t('geofence.response.success_deleted'),
                            'success',
                            'tr',
                        );
                    });
                },
                bodyText: this.createOnProceedBody(calculations),
                proceedText: t('user_functionality.delete'),
                cancelText: t('common_phrases.no'),
                cancelButtonColor: ButtonColors.NOTIFY,
                proceedButtonColor: ButtonColors.DANGER,
            },
            title: calculation.name,
            noButtons: true,
        });
    }

    createOnProceedBody(calculations) {
        const { t } = this.props;
        return (
            <>
                {t('geofence.on_proceed_body')}
                <br />
                <br />
                {t('geofence.geofence_calculation_used')}
                <pre style={{ maxHeight: '100px', overflowY: 'scroll' }}>
                    {calculations.geoFenceCalculations.map(item => {
                        return (
                            <span key={item.id}>
                                {item.name} - {item.company.companyName} - {item.surcharge.amount}{' '}
                                {item.surcharge.currency}
                                <br />
                            </span>
                        );
                    })}
                </pre>
                {t('geofence.geozone_calculations_used')}

                <pre style={{ maxHeight: '100px', overflowY: 'scroll' }}>
                    {calculations.geoZoneCalculations.map(item => {
                        return (
                            <span key={item.id}>
                                {item.name} - {item.company.companyName} - {item.flatRate.amount}{' '}
                                {item.flatRate.currency}
                                <br />
                            </span>
                        );
                    })}
                </pre>
            </>
        );
    }

    render() {
        const { geofenceAreas, t } = this.props;
        const { searchQuery, inEditMode } = this.state;

        if (geofenceAreas.isFetching) return <div className="text-center p-4">{t('common_phrases.loading')}</div>;

        if (!geofenceAreas.items || geofenceAreas.items.length === 0) {
            return <div className="p-4">{t('geofence.state.no_entry')}</div>;
        }

        const filteredItems = geofenceAreas.items.filter(item => {
            const query = searchQuery.toLowerCase().trim();
            if (!query) return true;

            const nameMatches = item.name && item.name.toLowerCase().includes(query);

            const companyNameMatches =
                item.company && item.company.companyName && item.company.companyName.toLowerCase().includes(query);

            return nameMatches || companyNameMatches;
        });

        return (
            <div className="col-md-12">
                <div className="row mb-3" style={{ marginTop: 20, marginBottom: 20 }}>
                    <div className="col-12 col-md-4">
                        <div className="input-group">
                            <span className="input-group-addon">
                                <i className="glyphicon glyphicon-search" />
                            </span>
                            <input
                                type="text"
                                className="form-control"
                                placeholder={t('common_phrases.search')}
                                value={searchQuery}
                                onChange={this.handleSearchChange}
                            />
                            {searchQuery && (
                                <span
                                    className="input-group-btn"
                                    onClick={() => this.setState({ searchQuery: '' })}
                                    style={{ cursor: 'pointer' }}>
                                    <button className="btn btn-default" type="button">
                                        ×
                                    </button>
                                </span>
                            )}
                        </div>
                    </div>
                    {searchQuery && (
                        <div className="col-12 mt-2 text-muted small">
                            {t('geofence.state.foun_entries', { count: filteredItems.length })}
                        </div>
                    )}
                </div>
                <div
                    className="row"
                    style={{
                        marginTop: '10px',
                        maxHeight: '50vh',
                        overflowY: 'auto',
                    }}>
                    {filteredItems.map(item => (
                        <div
                            key={item.id}
                            style={{
                                paddingBottom: '25px',
                            }}
                            className="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-12 d-flex align-items-stretch"
                            onMouseEnter={() => {
                                if (!this.state.inEditMode && this.props.onHoverArea) this.props.onHoverArea(item);
                            }}
                            onMouseLeave={() => {
                                if (!this.state.inEditMode && this.props.onHoverArea) this.props.onHoverArea(null);
                            }}>
                            <div
                                className="card w-100 p-3 shadow-sm"
                                style={{
                                    justifyContent: 'space-between',
                                    ...(inEditMode != null &&
                                        inEditMode.id === item.id && {
                                            borderBottom: '4px solid green',
                                            backgroundColor: '#f0f8ff',
                                        }),
                                }}>
                                <div>
                                    <h4>{item.name}</h4>
                                    {item.company && (
                                        <p
                                            className="text-muted small mb-3 text-truncate"
                                            title={item.company.companyName}>
                                            {t('geofence.visible_for')}
                                            {item.company.companyName ? item.company.companyName : 'global'}
                                        </p>
                                    )}
                                </div>

                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                    <button
                                        type="button"
                                        className="btn btn-link text-danger p-0"
                                        onClick={() => {
                                            if (this.state.inEditMode != null) this.props.setGeoFenceForEdit(null);
                                            else this.props.setGeoFenceForEdit(item);

                                            this.setState({
                                                inEditMode: this.state.inEditMode != null ? null : item,
                                            });
                                        }}
                                        style={{ display: 'flex', gap: 4, alignItems: 'bottom' }}>
                                        <span className="glyphicon glyphicon-pencil" />
                                        <span>{t('user_functionality.edit')}</span>
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-link text-danger p-0"
                                        onClick={() => {
                                            asyncRequest(
                                                `${TOMCAT_URL}api/${Entities.GEOFENCE_AREA.repository}/get/${item.id}/deletable`,
                                            )
                                                .then(response => {
                                                    this.openConfirmDeleteDialog(item, response.json);
                                                })
                                                .catch(() => this.openCannotDeleteDialog());
                                        }}
                                        style={{ display: 'flex', gap: 4, alignItems: 'bottom' }}>
                                        <span className="glyphicon glyphicon-trash text-danger" />
                                        <span className="text-danger">{t('user_functionality.delete')}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

export default withTranslation()(composeModalActions(AdminGeofenceAreaItems));
